import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import {
  Avatar,
  Typography,
  Box,
  Button,
  IconButton,
  Collapse,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { drawerWidth } from "../Sidebar";
import api from "../../services/api";

function ActiveUsers() {
  const [sliderRef, setSliderRef] = useState(null);
  const [isPrevArrowActive, setPrevArrowActive] = useState(false);
  const [isNextArrowActive, setNextArrowActive] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    api.get("/active-users").then((response) => {
      setUsers(response.data);
    });

    setTimeout(() => {
      setRefresh(refresh + 1);
    }, 5000);
  }, [refresh]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const setArrowStates = (index) => {
    const isPrevArrowActive = index > 0;
    const isNextArrowActive = index < users.length - 5;
    setPrevArrowActive(isPrevArrowActive);
    setNextArrowActive(isNextArrowActive);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    beforeChange: (oldIndex, newIndex) => {
      setArrowStates(newIndex);
    },
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: drawerWidth,
        right: 0,
        backgroundColor: "#F3F6FA",
        boxShadow: "0px -2px 5px rgba(0,0,0,0.1)",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          backgroundColor: "#E0E0E0",
        }}
        onClick={handleToggle}
      >
        <Typography variant="h6">Usuários ativos no sistema</Typography>
        <IconButton>
          {isOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
      </Box>

      <Collapse in={isOpen}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "10px 0px 10px 10px",
            height: "100%",
          }}
        >
          <IconButton
            onClick={() => sliderRef.slickPrev()}
            disabled={!isPrevArrowActive}
            sx={{
              backgroundColor: isPrevArrowActive ? "#007BFF" : "#E0E0E0",
              color: "white",
              marginRight: "10px",
              width: "50px",
              height: "50px",
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>

          <Box
            sx={{
              flex: 1,
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <Slider ref={(slider) => setSliderRef(slider)} {...settings}>
              {users.map((user, index) => (
                <Box key={index} sx={{ textAlign: "center", padding: "10px" }}>
                  <Avatar sx={{ width: 56, height: 56, margin: "0 auto" }} />
                  <Typography variant="body2">{user.name}</Typography>
                  <Typography
                    variant="caption"
                    color={user.status === "online" ? "green" : "gray"}
                  >
                    {user.status === "online" ? "🟢 Online" : "⚫ Offline"}
                  </Typography>
                </Box>
              ))}
            </Slider>
          </Box>

          <IconButton
            onClick={() => sliderRef.slickNext()}
            disabled={!isNextArrowActive}
            sx={{
              backgroundColor: isNextArrowActive ? "#007BFF" : "#E0E0E0",
              color: "white",
              marginLeft: "10px",
              width: "50px",
              height: "50px",
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>

          {/* <div style={{ height: "100%" }}>
            <Button
              variant="contained"
              sx={{
                color: "blue",
                backgroundColor: "#d9e3f3",
                marginLeft: "10px",
                height: "50px",
                padding: "0 20px",
                display: "flex",
                borderRadius: 0,
                "&:hover": {
                  backgroundColor: "#d9e3f3",
                },
                alignItems: "center",
                marginTop: "-10px",
                height: "calc(100% + 20px)",
              }}
            >
              Detalhes
            </Button>
          </div> */}
        </Box>
      </Collapse>
    </Box>
  );
}

export default ActiveUsers;
